import { connect } from 'react-redux'
import SchoolGeneral from './school-general'
import {
  getSchool,
  getUpdateSchoolRequest
} from '../../../../../stores/school/school.selectors'
import { updateSchool } from '../../../../../stores/school/school.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = (state, { me }) => {
  const school = getSchool(state)
  const updateSchoolDetails = getUpdateSchoolRequest(state)
  return {
    pending: updateSchoolDetails.pending,
    id: school.id,
    title: school.title || '-',
    city: school.city || '-',
    country: school.country || '-',
    address: school.address || '-',
    postcode: school.postcode || '-',
    description: school.description,
    hide_year_group: school.hide_year_group,
    website: school.website,
    twitter: school.twitter_handler
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }) => ({
  ...stateProps,
  onSubmit: values => {
    const data = {
      description: values.description,
      hide_year_group: values.hide_year_group,
      website: values.website,
      twitter_handler: values.twitter
    }
    dispatch(updateSchool(stateProps.id, data))
      .then(() =>
        toast.success('Your school details were successfully updated.')
      )
      .catch(errorHandler)
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SchoolGeneral)
